import GlobalHook from "use-global-hook";
import * as actions from "./actions";

const initialState = {

  subscribeDateEnd: null,
  subscribeRemainingDays: null,
  
  parsingDate: null,
  parsingFolder: null,
  parsingNextTime: null,

  isDataLoaded: false,

  user: {

    email: null,
    company_name: null,
    fio: null,
    phone: null

  }

};

const useGlobal = GlobalHook( initialState, actions );

export default useGlobal;